import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "page-modal" }
const _hoisted_2 = { class: "dialog-footer" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("确定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ZpForm = _resolveComponent("ZpForm")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.isDialog,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isDialog) = $event)),
      title: "新建用户",
      width: "30%",
      center: ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDialog = false))
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.handleConfirmClick
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_ZpForm, _mergeProps(_ctx.modalConfig, {
          modelValue: _ctx.formData,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData) = $event))
        }), null, 16, ["modelValue"]),
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["modelValue"])
  ]))
}